import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

export default ({ api, method = 'get', params = {} }) => {

	const token = useSelector(s => s.app.token);
	const [response, setResponse] = useState(null);
	const [error, setError] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const fetchData = async () => {
			try {
				// todo, set headers in axios
				axios.defaults.headers['x-auth-token'] = token;

				axios({
					method,
					url: api,
					params: params || {},
				})
					.then(response => {
						setResponse(response.data);
					})
					.catch(() => {
						setError(true);
					})
					.finally(() => {
						setIsLoading(false);
					});
			} catch (err) {
				setError(err);
			}
		};

		fetchData();
	}, [api]);

	return { response, isLoading, error };
};
